module.exports = __webpack_public_path__ + "img/exchange_ban.png";